import React, {lazy, Suspense} from "react";
// reactstrap components

// core components
import ColorNavbar from "components/Navbars/ColorNavbar.js";
import FooterBlack from "components/Footers/FooterBlack.js";
// sections for this page
import SectionAudit from "./sections-services/SectionAudit.js";
import SectionContactUs from "./sections-sections/SectionContactUs.js";
import SectionPentest from "./sections-services/SectionPentest.js";
import AboutUsHeader from "components/Headers/AboutUsHeader.js";
import SectionSolution from "./sections-services/SectionSolution.js";
import { useTranslation } from 'react-i18next';

/*const renderLoader = () => <p>Loading</p>;

const SectionAudit = lazy(() => import('./sections-services/SectionAudit.js'));
const SectionPentest = lazy(() => import('./sections-services/SectionPentest.js'));
const AboutUsHeader = lazy(() => import("components/Headers/AboutUsHeader.js"));

const SectionContactUs = lazy(() => import("./sections-sections/SectionContactUs.js"));
const SectionSolution = lazy(() => import("./sections-services/SectionSolution.js"));

const ColorNavbar = lazy(() => import("components/Navbars/ColorNavbar.js"));
const FooterBlack = lazy(() => import("components/Footers/FooterBlack.js"));*/



function Services() {

  const { t, i18n } = useTranslation();
  if(!localStorage.getItem('lang'))
    localStorage.setItem('lang', "fr");
  else {
    i18n.changeLanguage(localStorage.getItem('lang'));
  }
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("section-page");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    var href = window.location.href.substring(
      window.location.href.lastIndexOf("#/") + 2
    );
    var hrefId = href.substring(href.lastIndexOf("#") + 1);
    if (href.lastIndexOf("#") > 0) {
      document.getElementById(hrefId).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
    // this function is used to make the right bullets list
    // (the bellow <nav id="cd-vertical-nav">)
    // active when changeing the section on scroll
    const updateView = () => {
      var contentSections = document.getElementsByClassName("cd-section");
      var navigationItems = document
        .getElementById("cd-vertical-nav")
        .getElementsByTagName("a");

      for (let i = 0; i < contentSections.length; i++) {
        var activeSection =
          parseInt(navigationItems[i].getAttribute("data-number"), 10) - 1;
        if (
          contentSections[i].offsetTop - window.innerHeight / 2 <
            window.pageYOffset &&
          contentSections[i].offsetTop +
            contentSections[i].scrollHeight -
            window.innerHeight / 2 >
            window.pageYOffset
        ) {
          navigationItems[activeSection].classList.add("is-selected");
        } else {
          navigationItems[activeSection].classList.remove("is-selected");
        }
      }
    };

    window.addEventListener("scroll", updateView);
    return function cleanup() {
      document.body.classList.remove("section-page");
      window.removeEventListener("scroll", updateView);
    };
  });
  return (
    <>
    {/*<Suspense fallback={renderLoader()}>*/}
      <ColorNavbar />
      <AboutUsHeader />
      <div className="section-space" />
      <SectionPentest />
      <SectionAudit />
      <SectionSolution />
      <SectionContactUs />
      <nav id="cd-vertical-nav">
        <ul>
          <li>
            <a
              data-number="1"
              href="#pentest"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("pentest").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">{t('services.services_pentest')}</span>
            </a>
          </li>
          <li>
            <a
              data-number="2"
              href="#audit"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("audit").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">{t('services.services_audit')} & {t('services.services_consulting')}</span>
            </a>
          </li>
          <li>
            <a
              data-number="3"
              href="#solutions"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("solutions").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">{t('services.services_solutions')}</span>
            </a>
          </li>
          <li>
            <a
              data-number="4"
              href="#contact-us"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("contact-us").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">{t('about.about_contact_us')}</span>
            </a>
          </li>
        </ul>
      </nav>
      <FooterBlack />
    {/*</Suspense>*/}
    </>
  );
}

export default Services;
